import { Component, Inject, OnInit } from '@angular/core';
import {
  MatBottomSheetRef,
  MAT_BOTTOM_SHEET_DATA,
} from '@angular/material/bottom-sheet';
import { CookingStoryShoppinglistDateService } from 'src/app/data/repository/cooking-story/cooking-story-shoppinglist-date.service';

@Component({
  selector: 'app-shoppinglist-move-confirm',
  templateUrl: './shoppinglist-move-confirm.component.html',
  styles: [
    `
      .cooking-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #cccccc;
        height: 47px;
        position: sticky;
        background: white;
        width: calc(100% - 48px);
        box-sizing: border-box;
        top: 0;
        margin: 0 24px;
      }
      .title {
        display: flex;
        font-family: Vazir-Medium;
        font-size: 16px;
        color: #131314;
        align-items: center;
      }
      .title p {
        margin: 0;
      }
      .title img {
        padding-left: 4px;
        height: 24px;
        width: 24px;
      }
      .move-title {
        font-family: 'Vazir-Medium' !important;
        font-size: 16px;
        color: #131314;
        margin-right: 24px;
        margin-top: 27.5px;
        margin-bottom: 40px;
      }
      .button-holder {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 24px;
        margin-bottom: 23px;
      }
      .move-btn {
        height: 56px;
        background: #239ef7;
        color: #fff;
        border-radius: 24px;
        align-items: center;
        display: flex;
        font-family: 'Vazir-Bold' !important;
        font-size: 18px;
        min-width: calc(60% - 24px);
      }
      .move-btn span {
        width: 32px;
        height: 32px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #fff;
        border-radius: 12px;
        color: #239ef7;
        font-family: 'Vazir-Bold' !important;
        margin: 0 12px;
      }
      .cancel {
        min-width: calc(50% - 24px);
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-radius: 24px;
        border: 1px solid #239ef7;
        height: 56px;
        padding: 0 12px;
        box-sizing: border-box;
        color: #239ef7;
        font-family: 'Vazir-Bold' !important;
        font-size: 16px;
      }
      .cancel img {
        padding-left: 8px;
      }
    `,
  ],
})
export class ShoppinglistMoveConfirmComponent implements OnInit {
  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA)
    public data: string[],
    private bottomSheetRef: MatBottomSheetRef<ShoppinglistMoveConfirmComponent>,
    private cookingStoryShoppinglistDateService: CookingStoryShoppinglistDateService
  ) {}

  ngOnInit(): void {}
  move() {
    this.cookingStoryShoppinglistDateService
      .moveToKitcchen(this.data)
      .then(() => {
        this.cancel();
      });
  }
  cancel() {
    this.bottomSheetRef.dismiss();
  }
}
